<app-modal [maskClose]="true" [id]="modalId">
  <aside class="modal confirm-modal">
    <div class="modal-body">
      <div class="header">
        <div class="button regular close" (click)="close(modalId)"><span class="icon">&#x00D7;</span></div>
      </div>
      <div class="content-wrapper">
        <div>
          <div class="content">
            <h3 class="title">{{ options.title }}</h3>
            @for (line of options.text; track line) {
              <p class="content-text" [innerHtml]="line | keepHtml"></p>
            }
            @if (textList && textList.length) {
              <ul class="content-text-list">
                @for (extra of textList; track extra) {
                  <li>{{extra}}</li>
                }
              </ul>
            }
            <ng-content></ng-content>
          </div>
          <div class="footer">
            @for (action of options.actions; track action) {
              <button class="button regular"
                [ngClass]="{ 'solid-green': action.type === 'solid', 'button-text': action.type === 'text' }"
              (click)="action.callback($event)">{{ action.text }}</button>
            }
          </div>
        </div>
        <div class="owl-image">
          <img src="../../../assets/img/modals/error-modal/owl-reading.png" alt="">
        </div>
      </div>
    </div>
  </aside>
  <div class="confirm-modal-background"></div>
</app-modal>
